const timing = {
    "0":  15.390,
    "1":  15.396,
    "2":  15.405,
    "3":  15.415,
    "4":  15.419,
    "5":  15.428,
    "6":  15.436,
    "7":  15.445,
    "8":  15.452,
    "9":  15.461,
    "10":  15.465,
    "11":  15.470,
    "12":  15.478,
    "13":  15.487,
    "14":  15.493,
    "15":  15.502,
    "16":  15.509,
    "17":  15.518,
    "18":  15.532,
    "19":  15.538,
    "20":  15.541,
    "21":  15.553,
    "22":  15.558,
    "23":  15.568,
    "24":  15.576,
    "25":  15.585,
    "26":  15.592,
    "27":  15.600,
    "28":  15.606,
    "29":  15.615,
    "30":  15.624,
    "31":  15.633,
    "32":  15.637,
    "33":  15.646,
    "34":  15.655,
    "35":  15.663,
    "36":  15.668,
    "37":  15.675,
    "38":  15.684,
    "39":  15.696,
    "40":  15.698,
    "41":  15.708,
    "42":  15.716,
    "43":  15.726,
    "44":  15.73,
    "45":  15.743,
    "46":  15.745,
    "47":  15.753,
    "48":  15.767,
    "49":  15.771,
    "50":  15.780,
    "51":  15.788,
    "52":  15.797,
    "53":  15.806,
    "54":  15.814,
    "55":  15.818,
    "56":  15.827,
    "57":  15.838,
    "58":  15.847,
    "59":  15.854,
    "60":  15.859,
    "61":  15.868,
    "62":  15.877,
    "63":  15.884,
    "64":  15.889,
    "65":  15.896,
    "66":  15.904,
    "67":  15.913,
    "68":  15.921,
    "69":  15.927,
    "70":  15.936,
    "71":  15.943,
    "72":  15.952,
    "73":  15.967,
    "74":  15.975,
    "75":  15.984,
    "76":  15.990,
    "77":  15.999,
    "78":  16.006,
    "79":  16.016,
    "80":  16.023,
    "81":  16.032,
    "82":  16.040,
    "83":  16.044,
    "84":  16.056,
    "85":  16.064,
    "86":  16.069,
    "87":  16.073,
    "88":  16.088,
    "89":  16.094,
    "90":  16.103,
    "91":  16.112,
    "92":  16.121,
    "93":  16.130,
    "94":  16.133,
    "95":  16.142,
    "96":  16.151,
    "97":  16.160,
    "98":  16.168,
    "99":  16.177,
    "100":  16.186,
    "101":  16.193,
    "102":  16.202,
    "103":  16.210,
    "104":  16.216,
    "105":  16.224,
    "106":  16.232,
    "107":  16.244,
    "108":  16.252,
    "109":  16.258,
    "110":  16.267,
    "111":  16.275,
    "112":  16.285,
    "113":  16.293,
    "114":  16.302,
    "115":  16.306,
    "116":  16.315,
    "117":  16.323,
    "118":  16.332,
    "119":  16.341,
    "120":  16.35,
    "121":  16.359,
    "122":  16.366,
    "123":  16.375,
    "124":  16.384,
    "125":  16.392,
    "126":  16.395,
    "127":  16.409,
    "128":  16.416,
    "129":  16.427,
    "130":  16.433,
    "131":  16.445,
    "132":  16.451,
    "133":  16.46,
    "134":  16.465,
    "135":  16.472,
    "136":  16.482,
    "137":  16.490,
    "138":  16.499,
    "139":  16.505,
    "140":  16.519,
    "141":  16.525,
    "142":  16.537,
    "143":  16.543,
    "144":  16.553,
    "145":  16.561,
    "146":  16.570,
    "147":  16.576,
    "148":  16.585,
    "149":  16.592,
    "150":  16.601,
    "151":  16.609,
    "152":  16.618,
    "153":  16.627,
    "154":  16.636,
    "155":  16.645,
    "156":  16.654,
    "157":  16.660,
    "158":  16.668,
    "159":  16.674,
    "160":  16.690,
    "161":  16.697,
    "162":  16.707,
    "163":  16.716,
    "164":  16.722,
    "165":  16.731,
    "166":  16.736,
    "167":  16.743,
    "168":  16.755,
    "169":  16.762,
    "170":  16.773,
    "171":  16.779,
    "172":  16.788,
    "173":  16.799,
    "174":  16.803,
    "175":  16.814,
    "176":  16.823,
    "177":  16.832,
    "178":  16.839,
    "179":  16.847,
    "180":  16.863,
    "181":  16.871,
    "182":  16.880,
    "183":  16.887,
    "184":  16.895,
    "185":  16.904,
    "186":  16.910,
    "187":  16.918,
    "188":  16.927,
    "189":  16.942,
    "190":  16.951,
    "191":  16.957,
    "192":  16.966,
    "193":  16.976,
    "194":  16.979,
    "195":  16.990,
    "196":  17.002,
    "197":  17.012,
    "198":  17.022,
    "199":  17.031,
    "200":  17.038,
    "201":  17.047,
    "202":  17.055,
    "203":  17.064,
    "204":  17.073,
    "205":  17.077,
    "206":  17.086,
    "207":  17.101,
    "208":  17.106,
    "209":  17.116,
    "210":  17.124,
    "211":  17.133,
    "212":  17.142,
    "213":  17.151,
    "214":  17.159,
    "215":  17.172,
    "216":  17.181,
    "217":  17.189,
    "218":  17.198,
    "219":  17.207,
    "220":  17.216,
    "221":  17.223,
    "222":  17.235,
    "223":  17.244,
    "224":  17.253,
    "225":  17.261,
    "226":  17.270,
    "227":  17.279,
    "228":  17.288,
    "229":  17.296,
    "230":  17.305,
    "231":  17.317,
    "232":  17.324,
    "233":  17.333,
    "234":  17.342,
    "235":  17.350,
    "236":  17.356,
    "237":  17.371,
    "238":  17.376,
    "239":  17.387,
    "240":  17.398,
    "241":  17.406,
    "242":  17.416,
    "243":  17.424,
    "244":  17.430,
    "245":  17.443,
    "246":  17.451,
    "247":  17.463,
    "248":  17.469,
    "249":  17.481,
    "250":  17.487,
    "251":  17.499,
    "252":  17.505,
    "253":  17.517,
    "254":  17.525,
    "255":  17.537,
    "256":  17.543,
    "257":  17.555,
    "258":  17.561,
    "259":  17.574,
    "260":  17.579,
    "261":  17.592,
    "262":  17.6,
    "263":  17.612,
    "264":  17.618,
    "265":  17.630,
    "266":  17.637,
    "267":  17.65,
    "268":  17.659,
    "269":  17.666,
    "270":  17.674,
    "271":  17.686,
    "272":  17.695,
    "273":  17.704,
    "274":  17.713,
    "275":  17.722,
    "276":  17.731,
    "277":  17.741,
    "278":  17.752,
    "279":  17.759,
    "280":  17.770,
    "281":  17.779,
    "282":  17.788,
    "283":  17.796,
    "284":  17.808,
    "285":  17.815,
    "286":  17.827,
    "287":  17.832,
    "288":  17.845,
    "289":  17.857,
    "290":  17.865,
    "291":  17.877,
    "292":  17.886,
    "293":  17.889,
    "294":  17.904,
    "295":  17.915,
    "296":  17.924,
    "297":  17.933,
    "298":  17.940,
    "299":  17.945,
    "300":  17.960,
    "301":  17.970,
    "302":  17.979,
    "303":  17.993,
    "304":  18.002,
    "305":  18.009,
    "306":  18.019,
    "307":  18.028,
    "308":  18.041,
    "309":  18.049,
    "310":  18.058,
    "311":  18.070,
    "312":  18.079,
    "313":  18.088,
    "314":  18.094,
    "315":  18.103,
    "316":  18.115,
    "317":  18.124,
    "318":  18.134,
    "319":  18.148,
    "320":  18.153,
    "321":  18.168,
    "322":  18.177,
    "323":  18.186,
    "324":  18.195,
    "325":  18.204,
    "326":  18.216,
    "327":  18.225,
    "328":  18.237,
    "329":  18.247,
    "330":  18.255,
    "331":  18.264,
    "332":  18.278,
    "333":  18.287,
    "334":  18.296,
    "335":  18.305,
    "336":  18.317,
    "337":  18.326,
    "338":  18.335,
    "339":  18.344,
    "340":  18.357,
    "341":  18.366,
    "342":  18.375,
    "343":  18.383,
    "344":  18.398,
    "345":  18.407,
    "346":  18.416,
    "347":  18.428,
    "348":  18.437,
    "349":  18.439,
    "350":  18.457,
    "351":  18.464,
    "352":  18.476,
    "353":  18.490,
    "354":  18.492,
    "355":  18.502,
    "356":  18.520,
    "357":  18.529,
    "358":  18.538,
    "359":  18.546,
    "360":  18.559,
    "361":  18.567,
    "362":  18.579,
    "363":  18.591,
    "364":  18.597,
    "365":  18.609,
    "366":  18.622,
    "367":  18.630,
    "368":  18.642,
    "369":  18.654,
    "370":  18.660,
    "371":  18.672,
    "372":  18.686,
    "373":  18.692,
    "374":  18.704,
    "375":  18.716,
    "376":  18.722,
    "377":  18.734,
    "378":  18.747,
    "379":  18.753,
    "380":  18.766,
    "381":  18.779,
    "382":  18.791,
    "383":  18.8,
    "384":  18.811,
    "385":  18.817,
    "386":  18.832,
    "387":  18.839,
    "388":  18.853,
    "389":  18.860,
    "390":  18.874,
    "391":  18.883,
    "392":  18.895,
    "393":  18.898,
    "394":  18.912,
    "395":  18.924,
    "396":  18.930,
    "397":  18.943,
    "398":  18.955,
    "399":  18.963,
    "400":  18.979,
    "401":  18.990,
    "402":  19.003,
    "403":  19.012,
    "404":  19.022,
    "405":  19.035,
    "406":  19.043,
    "407":  19.050,
    "408":  19.067,
    "409":  19.074,
    "410":  19.082,
    "411":  19.098,
    "412":  19.112,
    "413":  19.121,
    "414":  19.133,
    "415":  19.142,
    "416":  19.154,
    "417":  19.163,
    "418":  19.177,
    "419":  19.186,
    "420":  19.198,
    "421":  19.207,
    "422":  19.214,
    "423":  19.231,
    "424":  19.238,
    "425":  19.255,
    "426":  19.259,
    "427":  19.267,
    "428":  19.281,
    "429":  19.296,
    "430":  19.311,
    "431":  19.32,
    "432":  19.332,
    "433":  19.341,
    "434":  19.354,
    "435":  19.362,
    "436":  19.371,
    "437":  19.387,
    "438":  19.395,
    "439":  19.404,
    "440":  19.416,
    "441":  19.431,
    "442":  19.445,
    "443":  19.454,
    "444":  19.467,
    "445":  19.476,
    "446":  19.485,
    "447":  19.502,
    "448":  19.511,
    "449":  19.525,
    "450":  19.532,
    "451":  19.546,
    "452":  19.558,
    "453":  19.570,
    "454":  19.579,
    "455":  19.592,
    "456":  19.606,
    "457":  19.615,
    "458":  19.627,
    "459":  19.637,
    "460":  19.651,
    "461":  19.660,
    "462":  19.674,
    "463":  19.686,
    "464":  19.695,
    "465":  19.707,
    "466":  19.720,
    "467":  19.732,
    "468":  19.746,
    "469":  19.755,
    "470":  19.767,
    "471":  19.779,
    "472":  19.793,
    "473":  19.805,
    "474":  19.811,
    "475":  19.820,
    "476":  19.833,
    "477":  19.851,
    "478":  19.865,
    "479":  19.871,
    "480":  19.883,
    "481":  19.895,
    "482":  19.907,
    "483":  19.919,
    "484":  19.933,
    "485":  19.945,
    "486":  19.957,
    "487":  19.969,
    "488":  19.981,
    "489":  19.993,
    "490":  20.005,
    "491":  20.017,
    "492":  20.029,
    "493":  20.041,
    "494":  20.053,
    "495":  20.065,
    "496":  20.077,
    "497":  20.091,
    "498":  20.097,
    "499":  20.116,
    "500":  20.127,
    "501":  20.139,
    "502":  20.154,
    "503":  20.166,
    "504":  20.18,
    "505":  20.192,
    "506":  20.204,
    "507":  20.213,
    "508":  20.226,
    "509":  20.240,
    "510":  20.252,
    "511":  20.264,
    "512":  20.273,
    "513":  20.293,
    "514":  20.303,
    "515":  20.311,
    "516":  20.323,
    "517":  20.341,
    "518":  20.356,
    "519":  20.368,
    "520":  20.380,
    "521":  20.387,
    "522":  20.404,
    "523":  20.419,
    "524":  20.428,
    "525":  20.442,
    "526":  20.454,
    "527":  20.467,
    "528":  20.484,
    "529":  20.497,
    "530":  20.511,
    "531":  20.523,
    "532":  20.537,
    "533":  20.549,
    "534":  20.562,
    "535":  20.576,
    "536":  20.588,
    "537":  20.600,
    "538":  20.615,
    "539":  20.627,
    "540":  20.636,
    "541":  20.647,
    "542":  20.668,
    "543":  20.679,
    "544":  20.684,
    "545":  20.707,
    "546":  20.716,
    "547":  20.729,
    "548":  20.743,
    "549":  20.755,
    "550":  20.769,
    "551":  20.782,
    "552":  20.796,
    "553":  20.808,
    "554":  20.821,
    "555":  20.835,
    "556":  20.848,
    "557":  20.868,
    "558":  20.881,
    "559":  20.895,
    "560":  20.907,
    "561":  20.921,
    "562":  20.933,
    "563":  20.946,
    "564":  20.96,
    "565":  20.975,
    "566":  20.993,
    "567":  21.005,
    "568":  21.019,
    "569":  21.032,
    "570":  21.046,
    "571":  21.058,
    "572":  21.070,
    "573":  21.089,
    "574":  21.103,
    "575":  21.115,
    "576":  21.127,
    "577":  21.145,
    "578":  21.157,
    "579":  21.171,
    "580":  21.183,
    "581":  21.198,
    "582":  21.217,
    "583":  21.228,
    "584":  21.237,
    "585":  21.259,
    "586":  21.273,
    "587":  21.288,
    "588":  21.300,
    "589":  21.318,
    "590":  21.329,
    "591":  21.347,
    "592":  21.359,
    "593":  21.377,
    "594":  21.389,
    "595":  21.403,
    "596":  21.419,
    "597":  21.431,
    "598":  21.448,
    "599":  21.461,
    "600":  21.478,
    "601":  21.493,
    "602":  21.509,
    "603":  21.523,
    "604":  21.535,
    "605":  21.553,
    "606":  21.57,
    "607":  21.585,
    "608":  21.595,
    "609":  21.612,
    "610":  21.627,
    "611":  21.645,
    "612":  21.654,
    "613":  21.666,
    "614":  21.686,
    "615":  21.704,
    "616":  21.722,
    "617":  21.735,
    "618":  21.752,
    "619":  21.764,
    "620":  21.779,
    "621":  21.794,
    "622":  21.811,
    "623":  21.82,
    "624":  21.842,
    "625":  21.859,
    "626":  21.877,
    "627":  21.889,
    "628":  21.906,
    "629":  21.922,
    "630":  21.940,
    "631":  21.957,
    "632":  21.972,
    "633":  21.987,
    "634":  22.000,
    "635":  22.023,
    "636":  22.038,
    "637":  22.055,
    "638":  22.071,
    "639":  22.085,
    "640":  22.100,
    "641":  22.116,
    "642":  22.139,
    "643":  22.154,
    "644":  22.169,
    "645":  22.186,
    "646":  22.201,
    "647":  22.216,
    "648":  22.231,
    "649":  22.255,
    "650":  22.272,
    "651":  22.287,
    "652":  22.302,
    "653":  22.318,
    "654":  22.341,
    "655":  22.356,
    "656":  22.365,
    "657":  22.384,
    "658":  22.395,
    "659":  22.424,
    "660":  22.443,
    "661":  22.461,
    "662":  22.476,
    "663":  22.494,
    "664":  22.511,
    "665":  22.529,
    "666":  22.550,
    "667":  22.567,
    "668":  22.585,
    "669":  22.601,
    "670":  22.618,
    "671":  22.636,
    "672":  22.656,
    "673":  22.677,
    "674":  22.687,
    "675":  22.711,
    "676":  22.728,
    "677":  22.734,
    "678":  22.762,
    "679":  22.782,
    "680":  22.802,
    "681":  22.821,
    "682":  22.841,
    "683":  22.862,
    "684":  22.877,
    "685":  22.898,
    "686":  22.918,
    "687":  22.936,
    "688":  22.954,
    "689":  22.972,
    "690":  22.996,
    "691":  23.011,
    "692":  23.026,
    "693":  23.052,
    "694":  23.067,
    "695":  23.091,
    "696":  23.106,
    "697":  23.130,
    "698":  23.147,
    "699":  23.171,
    "700":  23.186,
    "701":  23.202,
    "702":  23.228,
    "703":  23.247,
    "704":  23.272,
    "705":  23.287,
    "706":  23.302,
    "707":  23.320,
    "708":  23.356,
    "709":  23.378,
    "710":  23.395,
    "711":  23.416,
    "712":  23.439,
    "713":  23.463,
    "714":  23.484,
    "715":  23.506,
    "716":  23.529,
    "717":  23.549,
    "718":  23.571,
    "719":  23.586,
    "720":  23.610,
    "721":  23.633,
    "722":  23.657,
    "723":  23.680,
    "724":  23.704,
    "725":  23.717,
    "726":  23.746,
    "727":  23.770,
    "728":  23.796,
    "729":  23.817,
    "730":  23.844,
    "731":  23.865,
    "732":  23.889,
    "733":  23.913,
    "734":  23.937,
    "735":  23.958,
    "736":  23.985,
    "737":  24.008,
    "738":  24.032,
    "739":  24.058,
    "740":  24.080,
    "741":  24.106,
    "742":  24.131,
    "743":  24.157,
    "744":  24.183,
    "745":  24.208,
    "746":  24.235,
    "747":  24.261,
    "748":  24.287,
    "749":  24.311,
    "750":  24.338,
    "751":  24.365,
    "752":  24.391,
    "753":  24.416,
    "754":  24.442,
    "755":  24.475,
    "756":  24.500,
    "757":  24.531,
    "758":  24.556,
    "759":  24.576,
    "760":  24.610,
    "761":  24.641,
    "762":  24.671,
    "763":  24.702,
    "764":  24.728,
    "765":  24.761,
    "766":  24.791,
    "767":  24.820,
    "768":  24.844,
    "769":  24.881,
    "770":  24.913,
    "771":  24.943,
    "772":  24.978,
    "773":  25.008,
    "774":  25.038,
    "775":  25.074,
    "776":  25.106,
    "777":  25.137,
    "778":  25.177,
    "779":  25.213,
    "780":  25.246,
    "781":  25.279,
    "782":  25.318,
    "783":  25.354,
    "784":  25.392,
    "785":  25.425,
    "786":  25.464,
    "787":  25.505,
    "788":  25.532,
    "789":  25.586,
    "790":  25.624,
    "791":  25.665,
    "792":  25.708,
    "793":  25.747,
    "794":  25.793,
    "795":  25.838,
    "796":  25.884,
    "797":  25.930,
    "798":  25.975,
    "799":  26.026,
    "800":  26.077,
    "801":  26.128,
    "802":  26.18,
    "803":  26.232,
    "804":  26.284,
    "805":  26.344,
    "806":  26.401,
    "807":  26.464,
    "808":  26.538,
    "809":  26.603,
    "810":  26.677,
    "811":  26.749,
    "812":  26.826,
    "813":  26.913,
    "814":  27.014,
    "815": 27.110,
    "816":  27.232,
    "817":  27.371,
    "818":  27.555,
    "819":  27.996,
    "820": 28,
    "-1025":  5.843,
    "-1024":  5.859,
    "-1023":  5.875,
    "-1022":  5.890,
    "-1021":  5.906,
    "-1020":  5.922,
    "-1019":  5.939,
    "-1018":  5.948,
    "-1017":  5.970,
    "-1016":  5.991,
    "-1015":  6.003,
    "-1014":  6.020,
    "-1013":  6.038,
    "-1012":  6.055,
    "-1011":  6.068,
    "-1010":  6.086,
    "-1009":  6.103,
    "-1008":  6.116,
    "-1007":  6.134,
    "-1006":  6.150,
    "-1005":  6.163,
    "-1004":  6.180,
    "-1003":  6.198,
    "-1002":  6.210,
    "-1001":  6.224,
    "-1000":  6.242,
    "-999":  6.259,
    "-998":  6.270,
    "-997":  6.290,
    "-996":  6.299,
    "-995":  6.32,
    "-994":  6.336,
    "-993":  6.348,
    "-992":  6.361,
    "-991":  6.381,
    "-990":  6.393,
    "-989":  6.412,
    "-988":  6.425,
    "-987":  6.439,
    "-985":  6.471,
    "-984":  6.484,
    "-983":  6.497,
    "-982":  6.517,
    "-981":  6.530,
    "-980":  6.543,
    "-979":  6.556,
    "-978":  6.576,
    "-977":  6.590,
    "-976":  6.603,
    "-975":  6.616,
    "-974":  6.629,
    "-973":  6.643,
    "-972":  6.663,
    "-971":  6.677,
    "-970":  6.689,
    "-969":  6.707,
    "-968":  6.720,
    "-967":  6.733,
    "-966":  6.750,
    "-965":  6.763,
    "-964":  6.775,
    "-963":  6.794,
    "-962":  6.808,
    "-961":  6.82,
    "-960":  6.832,
    "-959":  6.851,
    "-958":  6.864,
    "-957":  6.876,
    "-956":  6.889,
    "-955":  6.908,
    "-954":  6.921,
    "-953":  6.933,
    "-952":  6.946,
    "-951":  6.964,
    "-950":  6.977,
    "-949":  6.991,
    "-948":  7.003,
    "-947":  7.015,
    "-946":  7.024,
    "-945":  7.035,
    "-944":  7.055,
    "-943":  7.074,
    "-942":  7.086,
    "-941":  7.099,
    "-940":  7.112,
    "-939":  7.129,
    "-938":  7.142,
    "-937":  7.155,
    "-936":  7.168,
    "-935":  7.181,
    "-934":  7.195,
    "-933":  7.206,
    "-932":  7.223,
    "-931":  7.236,
    "-930":  7.25,
    "-929":  7.262,
    "-928":  7.274,
    "-927":  7.288,
    "-926":  7.302,
    "-925":  7.317,
    "-924":  7.329,
    "-923":  7.334,
    "-922":  7.355,
    "-921":  7.365,
    "-920":  7.382,
    "-919":  7.396,
    "-918":  7.409,
    "-916":  7.436,
    "-915":  7.448,
    "-914":  7.461,
    "-913":  7.474,
    "-912":  7.487,
    "-911":  7.500,
    "-910":  7.509,
    "-909":  7.526,
    "-908":  7.539,
    "-907":  7.552,
    "-906":  7.565,
    "-905":  7.578,
    "-904":  7.589,
    "-903":  7.596,
    "-902":  7.614,
    "-901":  7.628,
    "-900":  7.635,
    "-899":  7.649,
    "-898":  7.662,
    "-897":  7.674,
    "-896":  7.687,
    "-895":  7.699,
    "-894":  7.711,
    "-893":  7.724,
    "-892":  7.736,
    "-891":  7.75,
    "-890":  7.762,
    "-889":  7.774,
    "-888":  7.787,
    "-887":  7.799,
    "-886":  7.811,
    "-885":  7.824,
    "-884":  7.838,
    "-883":  7.851,
    "-882":  7.864,
    "-881":  7.878,
    "-880":  7.890,
    "-879":  7.897,
    "-878":  7.916,
    "-877":  7.922,
    "-876":  7.936,
    "-875":  7.948,
    "-874":  7.961,
    "-873":  7.974,
    "-870":  8.012,
    "-869":  8.025,
    "-868":  8.037,
    "-867":  8.044,
    "-866":  8.058,
    "-865":  8.07,
    "-864":  8.081,
    "-863":  8.094,
    "-862":  8.107,
    "-861":  8.119,
    "-860":  8.131,
    "-859":  8.143,
    "-858":  8.156,
    "-857":  8.168,
    "-855":  8.193,
    "-854":  8.200,
    "-853":  8.213,
    "-852":  8.226,
    "-851":  8.238,
    "-850":  8.251,
    "-849":  8.263,
    "-848":  8.269,
    "-847":  8.282,
    "-846":  8.294,
    "-845":  8.308,
    "-844":  8.32,
    "-843":  8.332,
    "-842":  8.345,
    "-841":  8.352,
    "-840":  8.366,
    "-839":  8.378,
    "-838":  8.391,
    "-837":  8.402,
    "-836":  8.415,
    "-835":  8.421,
    "-834":  8.437,
    "-833":  8.448,
    "-832":  8.456,
    "-831":  8.464,
    "-830":  8.480,
    "-829":  8.495,
    "-828":  8.503,
    "-827":  8.517,
    "-826":  8.526,
    "-825":  8.54,
    "-824":  8.552,
    "-823":  8.561,
    "-822":  8.573,
    "-821":  8.585,
    "-820":  8.593,
    "-819":  8.608,
    "-818":  8.616,
    "-817":  8.631,
    "-816":  8.639,
    "-815":  8.646,
    "-814":  8.662,
    "-813":  8.671,
    "-812":  8.686,
    "-811":  8.695,
    "-810":  8.707,
    "-809":  8.716,
    "-808":  8.730,
    "-807":  8.744,
    "-806":  8.751,
    "-805":  8.760,
    "-804":  8.776,
    "-803":  8.783,
    "-802":  8.793,
    "-801":  8.805,
    "-800":  8.818,
    "-799":  8.828,
    "-798":  8.842,
    "-797":  8.850,
    "-796":  8.864,
    "-795":  8.875,
    "-794":  8.884,
    "-793":  8.891,
    "-792":  8.905,
    "-791":  8.913,
    "-790":  8.93,
    "-789":  8.939,
    "-788":  8.951,
    "-787":  8.959,
    "-786":  8.972,
    "-785":  8.982,
    "-784":  8.994,
    "-783":  9.003,
    "-782":  9.015,
    "-781":  9.023,
    "-780":  9.036,
    "-779":  9.046,
    "-778":  9.058,
    "-777":  9.067,
    "-776":  9.079,
    "-775":  9.088,
    "-774":  9.097,
    "-773":  9.108,
    "-772":  9.123,
    "-771":  9.131,
    "-770":  9.142,
    "-769":  9.155,
    "-768":  9.165,
    "-767":  9.174,
    "-766":  9.183,
    "-765":  9.196,
    "-764":  9.204,
    "-763":  9.217,
    "-762":  9.226,
    "-760":  9.244,
    "-759":  9.254,
    "-758":  9.267,
    "-757":  9.276,
    "-756":  9.29,
    "-755":  9.297,
    "-754":  9.309,
    "-753":  9.323,
    "-752":  9.331,
    "-751":  9.340,
    "-750":  9.354,
    "-749":  9.363,
    "-748":  9.372,
    "-747":  9.384,
    "-746":  9.392,
    "-745":  9.405,
    "-744":  9.415,
    "-743":  9.422,
    "-741":  9.442,
    "-740":  9.449,
    "-739":  9.465,
    "-738":  9.473,
    "-737":  9.482,
    "-736":  9.495,
    "-735":  9.504,
    "-734":  9.516,
    "-733":  9.526,
    "-732":  9.54,
    "-731":  9.549,
    "-730":  9.558,
    "-729":  9.567,
    "-727":  9.587,
    "-726":  9.596,
    "-725":  9.604,
    "-724":  9.619,
    "-723":  9.628,
    "-722":  9.634,
    "-721":  9.643,
    "-720":  9.659,
    "-719":  9.668,
    "-718":  9.675,
    "-717":  9.690,
    "-716":  9.699,
    "-715":  9.706,
    "-714":  9.715,
    "-713":  9.730,
    "-712":  9.738,
    "-711":  9.747,
    "-710":  9.754,
    "-709":  9.770,
    "-708":  9.778,
    "-707":  9.786,
    "-706":  9.793,
    "-705":  9.809,
    "-704":  9.817,
    "-703":  9.825,
    "-701":  9.841,
    "-700":  9.855,
    "-699":  9.866,
    "-698":  9.873,
    "-697":  9.881,
    "-696":  9.897,
    "-695":  9.905,
    "-694":  9.913,
    "-693":  9.922,
    "-692":  9.936,
    "-691":  9.948,
    "-690":  9.956,
    "-689":  9.966,
    "-688":  9.976,
    "-687":  9.985,
    "-686":  9.997,
    "-685":  10.006,
    "-684":  10.013,
    "-683":  10.021,
    "-682":  10.034,
    "-681":  10.043,
    "-680":  10.052,
    "-679":  10.061,
    "-678":  10.073,
    "-677":  10.081,
    "-676":  10.086,
    "-675":  10.102,
    "-674":  10.110,
    "-673":  10.117,
    "-672":  10.126,
    "-671":  10.134,
    "-670":  10.142,
    "-668":  10.168,
    "-667":  10.175,
    "-666":  10.186,
    "-665":  10.196,
    "-664":  10.207,
    "-663":  10.215,
    "-662":  10.222,
    "-661":  10.230,
    "-660":  10.238,
    "-659":  10.253,
    "-658":  10.262,
    "-657":  10.270,
    "-656":  10.283,
    "-655":  10.290,
    "-654":  10.300,
    "-653":  10.311,
    "-652":  10.32,
    "-651":  10.328,
    "-650":  10.336,
    "-649":  10.344,
    "-648":  10.357,
    "-647":  10.367,
    "-646":  10.376,
    "-645":  10.385,
    "-644":  10.393,
    "-643":  10.402,
    "-642":  10.410,
    "-641":  10.424,
    "-640":  10.433,
    "-639":  10.440,
    "-638":  10.449,
    "-637":  10.458,
    "-636":  10.466,
    "-635":  10.479,
    "-634":  10.488,
    "-633":  10.497,
    "-632":  10.506,
    "-631":  10.513,
    "-630":  10.522,
    "-629":  10.531,
    "-628":  10.54,
    "-627":  10.552,
    "-626":  10.559,
    "-625":  10.568,
    "-624":  10.576,
    "-623":  10.588,
    "-622":  10.598,
    "-621":  10.607,
    "-620":  10.616,
    "-619":  10.623,
    "-618":  10.632,
    "-617":  10.638,
    "-616":  10.651,
    "-615":  10.659,
    "-614":  10.671,
    "-613":  10.677,
    "-612":  10.689,
    "-611":  10.695,
    "-610":  10.708,
    "-608":  10.721,
    "-607":  10.729,
    "-606":  10.742,
    "-605":  10.745,
    "-604":  10.757,
    "-603":  10.770,
    "-602":  10.780,
    "-601":  10.79,
    "-600":  10.799,
    "-599":  10.806,
    "-598":  10.815,
    "-597":  10.823,
    "-596":  10.831,
    "-595":  10.840,
    "-593":  10.861,
    "-592":  10.866,
    "-591":  10.875,
    "-590":  10.886,
    "-589":  10.889,
    "-588":  10.901,
    "-587":  10.909,
    "-586":  10.921,
    "-585":  10.93,
    "-584":  10.939,
    "-583":  10.949,
    "-582":  10.958,
    "-581":  10.967,
    "-580":  10.976,
    "-579":  10.985,
    "-578":  10.994,
    "-577":  11.003,
    "-576":  11.011,
    "-575":  11.019,
    "-574":  11.028,
    "-573":  11.036,
    "-572":  11.041,
    "-571":  11.050,
    "-570":  11.058,
    "-569":  11.073,
    "-568":  11.081,
    "-567":  11.088,
    "-566":  11.097,
    "-565":  11.108,
    "-564":  11.113,
    "-563":  11.120,
    "-562":  11.132,
    "-561":  11.140,
    "-560":  11.148,
    "-559":  11.153,
    "-558":  11.168,
    "-557":  11.178,
    "-556":  11.186,
    "-555":  11.193,
    "-553":  11.212,
    "-551":  11.229,
    "-550":  11.238,
    "-549":  11.247,
    "-548":  11.256,
    "-547":  11.262,
    "-546":  11.272,
    "-545":  11.279,
    "-544":  11.284,
    "-542":  11.305,
    "-541":  11.315,
    "-540":  11.324,
    "-539":  11.332,
    "-538":  11.340,
    "-537":  11.350,
    "-536":  11.358,
    "-535":  11.367,
    "-534":  11.375,
    "-533":  11.384,
    "-532":  11.391,
    "-531":  11.399,
    "-530":  11.407,
    "-529":  11.416,
    "-528":  11.421,
    "-527":  11.430,
    "-526":  11.442,
    "-525":  11.451,
    "-524":  11.460,
    "-523":  11.469,
    "-522":  11.473,
    "-521":  11.486,
    "-520":  11.492,
    "-519":  11.503,
    "-518":  11.511,
    "-517":  11.519,
    "-516":  11.524,
    "-515":  11.532,
    "-514":  11.543,
    "-513":  11.553,
    "-512":  11.561,
    "-511":  11.567,
    "-510":  11.574,
    "-509":  11.584,
    "-508":  11.593,
    "-507":  11.602,
    "-505":  11.619,
    "-503":  11.636,
    "-501":  11.650,
    "-499":  11.668,
    "-498":  11.675,
    "-497":  11.683,
    "-496":  11.692,
    "-495":  11.702,
    "-494":  11.710,
    "-493":  11.720,
    "-492":  11.724,
    "-491":  11.735,
    "-490":  11.744,
    "-489":  11.750,
    "-487":  11.768,
    "-486":  11.777,
    "-485":  11.786,
    "-484":  11.790,
    "-483":  11.797,
    "-482":  11.806,
    "-481":  11.814,
    "-480":  11.821,
    "-479":  11.828,
    "-478":  11.843,
    "-477":  11.852,
    "-476":  11.860,
    "-475":  11.866,
    "-474":  11.876,
    "-473":  11.884,
    "-472":  11.890,
    "-471":  11.900,
    "-470":  11.908,
    "-469":  11.918,
    "-468":  11.922,
    "-467":  11.931,
    "-466":  11.939,
    "-465":  11.948,
    "-463":  11.965,
    "-461":  11.979,
    "-460":  11.986,
    "-459":  11.995,
    "-458":  12.004,
    "-457":  12.012,
    "-456":  12.021,
    "-455":  12.030,
    "-454":  12.038,
    "-453":  12.047,
    "-452":  12.055,
    "-451":  12.064,
    "-450":  12.072,
    "-449":  12.075,
    "-448":  12.083,
    "-447":  12.095,
    "-446":  12.099,
    "-445":  12.11,
    "-444":  12.116,
    "-443":  12.125,
    "-442":  12.132,
    "-441":  12.143,
    "-440":  12.150,
    "-439":  12.156,
    "-438":  12.165,
    "-437":  12.174,
    "-436":  12.183,
    "-435":  12.189,
    "-433":  12.205,
    "-432":  12.213,
    "-431":  12.222,
    "-430":  12.227,
    "-429":  12.235,
    "-428":  12.244,
    "-427":  12.253,
    "-426":  12.261,
    "-425":  12.269,
    "-424":  12.278,
    "-423":  12.286,
    "-422":  12.291,
    "-421":  12.300,
    "-420":  12.309,
    "-419":  12.317,
    "-418":  12.325,
    "-416":  12.335,
    "-415":  12.343,
    "-414":  12.352,
    "-413":  12.36,
    "-412":  12.369,
    "-411":  12.375,
    "-410":  12.384,
    "-409":  12.391,
    "-407":  12.406,
    "-405":  12.422,
    "-404":  12.431,
    "-403":  12.439,
    "-402":  12.448,
    "-401":  12.453,
    "-400":  12.460,
    "-399":  12.472,
    "-398":  12.480,
    "-397":  12.486,
    "-396":  12.497,
    "-395":  12.501,
    "-394":  12.506,
    "-393":  12.517,
    "-392":  12.525,
    "-391":  12.535,
    "-390":  12.540,
    "-389":  12.549,
    "-388":  12.558,
    "-387":  12.567,
    "-386":  12.571,
    "-385":  12.579,
    "-384":  12.588,
    "-383":  12.597,
    "-382":  12.601,
    "-381":  12.610,
    "-380":  12.619,
    "-379":  12.628,
    "-378":  12.636,
    "-377":  12.642,
    "-376":  12.652,
    "-375":  12.655,
    "-374":  12.665,
    "-373":  12.672,
    "-372":  12.681,
    "-371":  12.689,
    "-370":  12.698,
    "-369":  12.702,
    "-367":  12.718,
    "-366":  12.727,
    "-365":  12.735,
    "-363":  12.747,
    "-362":  12.753,
    "-361":  12.759,
    "-360":  12.768,
    "-359":  12.780,
    "-358":  12.782,
    "-357":  12.793,
    "-356":  12.800,
    "-353":  12.824,
    "-352":  12.832,
    "-350":  12.846,
    "-349":  12.856,
    "-348":  12.863,
    "-347":  12.871,
    "-346":  12.880,
    "-344":  12.892,
    "-343":  12.901,
    "-342":  12.910,
    "-341":  12.913,
    "-340":  12.922,
    "-339":  12.930,
    "-338":  12.936,
    "-337":  12.942,
    "-336":  12.951,
    "-335":  12.961,
    "-333":  12.974,
    "-331":  12.988,
    "-329":  13.008,
    "-327":  13.023,
    "-326":  13.027,
    "-324":  13.043,
    "-323":  13.052,
    "-322":  13.059,
    "-321":  13.064,
    "-320":  13.068,
    "-319":  13.079,
    "-318":  13.088,
    "-317":  13.097,
    "-316":  13.104,
    "-315":  13.109,
    "-314":  13.118,
    "-313":  13.127,
    "-312":  13.130,
    "-311":  13.139,
    "-310":  13.148,
    "-309":  13.151,
    "-306":  13.174,
    "-305":  13.183,
    "-304":  13.190,
    "-303":  13.198,
    "-302":  13.207,
    "-301":  13.213,
    "-300":  13.220,
    "-299":  13.229,
    "-298":  13.232,
    "-296":  13.249,
    "-295":  13.258,
    "-294":  13.262,
    "-293":  13.270,
    "-292":  13.279,
    "-291":  13.288,
    "-290":  13.291,
    "-289":  13.300,
    "-288":  13.305,
    "-287":  13.312,
    "-286":  13.323,
    "-285":  13.327,
    "-283":  13.34,
    "-281":  13.360,
    "-280":  13.366,
    "-279":  13.374,
    "-278":  13.380,
    "-277":  13.386,
    "-275":  13.404,
    "-273":  13.418,
    "-272":  13.424,
    "-271":  13.430,
    "-270":  13.437,
    "-269":  13.443,
    "-268":  13.451,
    "-267":  13.455,
    "-266":  13.469,
    "-265":  13.475,
    "-264":  13.481,
    "-263":  13.487,
    "-262":  13.493,
    "-261":  13.500,
    "-260":  13.510,
    "-258":  13.520,
    "-257":  13.532,
    "-256":  13.538,
    "-255":  13.549,
    "-254":  13.555,
    "-253":  13.561,
    "-252":  13.567,
    "-251":  13.576,
    "-250":  13.582,
    "-249":  13.591,
    "-248":  13.595,
    "-247":  13.604,
    "-246":  13.609,
    "-245":  13.618,
    "-243":  13.630,
    "-242":  13.639,
    "-240":  13.652,
    "-239":  13.661,
    "-237":  13.674,
    "-235":  13.687,
    "-234":  13.696,
    "-233":  13.704,
    "-232":  13.708,
    "-231":  13.717,
    "-230":  13.726,
    "-229":  13.729,
    "-228":  13.738,
    "-227":  13.747,
    "-226":  13.752,
    "-225":  13.761,
    "-224":  13.766,
    "-222":  13.776,
    "-221":  13.785,
    "-220":  13.796,
    "-219":  13.802,
    "-218":  13.807,
    "-217":  13.812,
    "-216":  13.821,
    "-215":  13.827,
    "-214":  13.832,
    "-213":  13.844,
    "-212":  13.847,
    "-211":  13.856,
    "-210":  13.863,
    "-209":  13.872,
    "-208":  13.880,
    "-207":  13.888,
    "-203":  13.916,
    "-202":  13.923,
    "-201":  13.924,
    "-199":  13.940,
    "-198":  13.949,
    "-197":  13.951,
    "-196":  13.958,
    "-194":  13.975,
    "-193":  13.985,
    "-192":  13.990,
    "-191":  13.999,
    "-189":  14.012,
    "-188":  14.017,
    "-187":  14.023,
    "-186":  14.032,
    "-184":  14.041,
    "-183":  14.049,
    "-182":  14.059,
    "-181":  14.068,
    "-180":  14.076,
    "-179":  14.083,
    "-177":  14.092,
    "-176":  14.101,
    "-175":  14.109,
    "-173":  14.124,
    "-172":  14.129,
    "-170":  14.142,
    "-169":  14.151,
    "-168":  14.157,
    "-167":  14.166,
    "-166":  14.171,
    "-165":  14.18,
    "-163":  14.193,
    "-162":  14.196,
    "-161":  14.204,
    "-160":  14.213,
    "-159":  14.219,
    "-157":  14.235,
    "-156":  14.243,
    "-155":  14.248,
    "-154":  14.256,
    "-152":  14.270,
    "-151":  14.279,
    "-150":  14.283,
    "-149":  14.293,
    "-148":  14.300,
    "-147":  14.305,
    "-146":  14.311,
    "-145":  14.32,
    "-144":  14.324,
    "-143":  14.333,
    "-142":  14.341,
    "-141":  14.350,
    "-140":  14.357,
    "-139":  14.361,
    "-138":  14.371,
    "-137":  14.375,
    "-136":  14.384,
    "-135":  14.392,
    "-134":  14.398,
    "-133":  14.407,
    "-132":  14.415,
    "-131":  14.421,
    "-130":  14.424,
    "-129":  14.430,
    "-128":  14.439,
    "-127":  14.446,
    "-126":  14.454,
    "-125":  14.461,
    "-124":  14.466,
    "-123":  14.475,
    "-122":  14.481,
    "-121":  14.490,
    "-120":  14.497,
    "-119":  14.508,
    "-118":  14.512,
    "-117":  14.521,
    "-116":  14.526,
    "-115":  14.530,
    "-114":  14.543,
    "-113":  14.549,
    "-112":  14.556,
    "-111":  14.558,
    "-110":  14.565,
    "-109":  14.573,
    "-108":  14.580,
    "-107":  14.592,
    "-106":  14.598,
    "-105":  14.607,
    "-104":  14.612,
    "-103":  14.621,
    "-102":  14.628,
    "-101":  14.633,
    "-100":  14.642,
    "-98":  14.655,
    "-97":  14.666,
    "-96":  14.671,
    "-95":  14.680,
    "-94":  14.686,
    "-93":  14.695,
    "-92":  14.702,
    "-91":  14.71,
    "-90":  14.715,
    "-89":  14.719,
    "-88":  14.725,
    "-87":  14.734,
    "-86":  14.746,
    "-85":  14.752,
    "-84":  14.761,
    "-82":  14.776,
    "-80":  14.791,
    "-79":  14.799,
    "-78":  14.802,
    "-77":  14.808,
    "-76":  14.817,
    "-74":  14.832,
    "-73":  14.839,
    "-72":  14.848,
    "-71":  14.857,
    "-70":  14.857,
    "-69":  14.865,
    "-68":  14.874,
    "-67":  14.881,
    "-66":  14.889,
    "-65":  14.896,
    "-64":  14.904,
    "-63":  14.913,
    "-62":  14.918,
    "-61":  14.925,
    "-60":  14.936,
    "-59":  14.943,
    "-58":  14.952,
    "-56":  14.969,
    "-55":  14.975,
    "-54":  14.983,
    "-52":  14.991,
    "-51":  15.000,
    "-50":  15.008,
    "-49":  15.017,
    "-48":  15.024,
    "-47":  15.033,
    "-46":  15.040,
    "-45":  15.043,
    "-44":  15.056,
    "-43":  15.061,
    "-42":  15.070,
    "-41":  15.079,
    "-40":  15.085,
    "-38":  15.100,
    "-37":  15.109,
    "-36":  15.117,
    "-35":  15.118,
    "-34":  15.127,
    "-33":  15.134,
    "-32":  15.142,
    "-31":  15.151,
    "-30":  15.158,
    "-29":  15.168,
    "-28":  15.177,
    "-27":  15.180,
    "-26":  15.189,
    "-25":  15.195,
    "-24":  15.204,
    "-23":  15.213,
    "-22":  15.222,
    "-21":  15.229,
    "-20":  15.238,
    "-18":  15.255,
    "-17":  15.261,
    "-16":  15.269,
    "-15":  15.276,
    "-14":  15.280,
    "-13":  15.290,
    "-12":  15.299,
    "-11":  15.306,
    "-10":  15.314,
    "-9":  15.320,
    "-8":  15.327,
    "-7":  15.336,
    "-6":  15.344,
    "-5":  15.353,
    "-4":  15.359,
    "-3":  15.368,
    "-1":  15.381,
    "-1200":  0,
    "-1199":  0.621,
    "-1198":  0.762,
    "-1197":  0.879,
    "-1196":  0.977,
    "-1195":  1.078,
    "-1194":  1.160,
    "-1193":  1.234,
    "-1192":  1.319,
    "-1191":  1.388,
    "-1190":  1.457,
    "-1189":  1.526,
    "-1188":  1.575,
    "-1187":  1.646,
    "-1186":  1.706,
    "-1185":  1.759,
    "-1184":  1.811,
    "-1183":  1.864,
    "-1182":  1.920,
    "-1181":  1.965,
    "-1180":  2.013,
    "-1179":  2.060,
    "-1178":  2.088,
    "-1177":  2.148,
    "-1176":  2.195,
    "-1175":  2.242,
    "-1174":  2.281,
    "-1173":  2.323,
    "-1172":  2.365,
    "-1171":  2.408,
    "-1170":  2.448,
    "-1169":  2.487,
    "-1168":  2.527,
    "-1167":  2.567,
    "-1166":  2.597,
    "-1165":  2.638,
    "-1164":  2.676,
    "-1163":  2.710,
    "-1162":  2.75,
    "-1161":  2.782,
    "-1160":  2.817,
    "-1159":  2.853,
    "-1158":  2.884,
    "-1157":  2.918,
    "-1156":  2.952,
    "-1155":  2.983,
    "-1154":  3.018,
    "-1153":  3.049,
    "-1152":  3.080,
    "-1151":  3.111,
    "-1150":  3.141,
    "-1149":  3.171,
    "-1148":  3.205,
    "-1147":  3.236,
    "-1146":  3.262,
    "-1145":  3.292,
    "-1144":  3.323,
    "-1143":  3.352,
    "-1142":  3.382,
    "-1141":  3.408,
    "-1140":  3.437,
    "-1139":  3.462,
    "-1138":  3.494,
    "-1137":  3.520,
    "-1136":  3.540,
    "-1135":  3.568,
    "-1134":  3.604,
    "-1133":  3.626,
    "-1132":  3.658,
    "-1131":  3.681,
    "-1130":  3.706,
    "-1129":  3.734,
    "-1128":  3.762,
    "-1127":  3.788,
    "-1126":  3.814,
    "-1125":  3.839,
    "-1124":  3.861,
    "-1123":  3.887,
    "-1122":  3.913,
    "-1121":  3.939,
    "-1120":  3.960,
    "-1119":  3.986,
    "-1118":  4.011,
    "-1117":  4.033,
    "-1116":  4.059,
    "-1115":  4.082,
    "-1114":  4.103,
    "-1113":  4.128,
    "-1112":  4.150,
    "-1111":  4.177,
    "-1110":  4.198,
    "-1109":  4.224,
    "-1108":  4.245,
    "-1107":  4.267,
    "-1106":  4.289,
    "-1105":  4.315,
    "-1104":  4.335,
    "-1103":  4.359,
    "-1102":  4.378,
    "-1101":  4.400,
    "-1100":  4.424,
    "-1099":  4.448,
    "-1098":  4.464,
    "-1097":  4.487,
    "-1096":  4.511,
    "-1095":  4.527,
    "-1094":  4.549,
    "-1093":  4.575,
    "-1092":  4.594,
    "-1091":  4.616,
    "-1090":  4.637,
    "-1089":  4.661,
    "-1088":  4.68,
    "-1087":  4.700,
    "-1086":  4.721,
    "-1085":  4.741,
    "-1084":  4.763,
    "-1083":  4.778,
    "-1082":  4.803,
    "-1081":  4.823,
    "-1080":  4.838,
    "-1079":  4.861,
    "-1078":  4.882,
    "-1077":  4.903,
    "-1076":  4.921,
    "-1075":  4.942,
    "-1074":  4.963,
    "-1073":  4.981,
    "-1072":  5.003,
    "-1071":  5.020,
    "-1070":  5.041,
    "-1069":  5.059,
    "-1068":  5.076,
    "-1067":  5.097,
    "-1066":  5.114,
    "-1065":  5.135,
    "-1064":  5.152,
    "-1063":  5.173,
    "-1062":  5.189,
    "-1061":  5.210,
    "-1060":  5.227,
    "-1059":  5.245,
    "-1058":  5.266,
    "-1057":  5.283,
    "-1056":  5.300,
    "-1055":  5.318,
    "-1054":  5.340,
    "-1053":  5.357,
    "-1052":  5.375,
    "-1051":  5.393,
    "-1050":  5.410,
    "-1049":  5.427,
    "-1048":  5.445,
    "-1047":  5.464,
    "-1046":  5.481,
    "-1045":  5.5,
    "-1044":  5.516,
    "-1043":  5.533,
    "-1042":  5.550,
    "-1041":  5.571,
    "-1040":  5.583,
    "-1039":  5.603,
    "-1038":  5.620,
    "-1037":  5.640,
    "-1036":  5.653,
    "-1035":  5.660,
    "-1034":  5.68,
    "-1033":  5.701,
    "-1032":  5.719,
    "-1031":  5.736,
    "-1030":  5.753,
    "-1029":  5.770,
    "-1028":  5.786,
    "-1027":  5.803,
    "-1026":  5.82,
    "-986":  6.458,
    "-917":  7.422,
    "-872":  7.987,
    "-871": 8,
    "-856":  8.181,
    "-761":  9.229,
    "-742":  9.433,
    "-728":  9.576,
    "-702":  9.834,
    "-609":  10.714,
    "-594":  10.852,
    "-554":  11.202,
    "-552":  11.220,
    "-543":  11.296,
    "-506":  11.610,
    "-504":  11.628,
    "-502":  11.641,
    "-500":  11.658,
    "-488":  11.759,
    "-464":  11.957,
    "-462":  11.974,
    "-417":  12.327,
    "-408":  12.399,
    "-406":  12.415,
    "-368":  12.710,
    "-364":  12.739,
    "-355":  12.811,
    "-354":  12.815,
    "-351":  12.841,
    "-345":  12.884,
    "-334":  12.970,
    "-330":  12.997,
    "-328":  13.008,
    "-325":  13.038,
    "-308":  13.160,
    "-307":  13.168,
    "-297":  13.241,
    "-282":  13.353,
    "-276":  13.392,
    "-274":  13.410,
    "-259":  13.517,
    "-244":  13.625,
    "-241":  13.648,
    "-238":  13.666,
    "-236":  13.683,
    "-205":  13.896,
    "-204":  13.907,
    "-200":  13.933,
    "-195":  13.969,
    "-190":  14.003,
    "-185":  14.040,
    "-178":  14.085,
    "-174":  14.118,
    "-171":  14.134,
    "-164":  14.184,
    "-99":  14.651,
    "-83":  14.767,
    "-75":  14.823,
    "-57":  14.96,
    "-53":  14.984,
    "-39":  15.094,
    "-19":  15.246,
    "-669":  10.156,
    "-434":  12.196,
    "-332":  12.981,
    "-284":  13.336,
    "-206":  13.889,
    "-158":  14.228,
    "-153":  14.261,
    "-81":  14.782,
};


module.exports = timing;